import { COLOR_THEME } from 'consts';

export function getMode(flowType = '') {
	switch (flowType) {
		case 'eb':
		case 'er':
		case 'rr-eb':
		case 'rr-er':
		case 'rr-su':
			return COLOR_THEME.SECONDARY;
		default:
			return COLOR_THEME.PRIMARY;
	}
}
